import React from "react";
import RevisionForm from "components/brief/util/helpers/RevisionForm";

// Every brief section publishes its changes as a revision through this same form. It
// renders content only: the caller decides whether it lives in a modal, a drawer or a
// panel, so a section that stops using a modal does not need a different component.
const SaveRevision = ({
  flow,
  revision,
  onSubmit,
}) =>
  <RevisionForm
    flow={flow}
    title="Registrar revisión%PA489"
    initialValues={{
      name: revision.name || "",
      description: revision.description || "",
    }}
    showNotificationEmails={true}
    onSubmit={onSubmit}
  />;

export default SaveRevision;
